// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2Mfiu","header":"MergedInvoice_header__3EYgs"};